// src/analyticsEvents.ts
import { AnalyticsEvent } from "../types/analyticsEvent";

export const ENQUIRY_FORM_SUBMIT_PERSONAL_SUCCESS: AnalyticsEvent = {
  category: "Enquiry Form",
  action: "Submit",
  label: "Personal Enquiry Submitted - Success",
};

export const ENQUIRY_FORM_SUBMIT_CLIENT_SUCCESS: AnalyticsEvent = {
  category: "Enquiry Form",
  action: "Submit",
  label: "Client Enquiry Submitted - Success",
};

export const ENQUIRY_FORM_SUBMIT_PERSONAL_FAILED: AnalyticsEvent = {
  category: "Enquiry Form",
  action: "Submit",
  label: "Personal Enquiry Submitted - Failed",
};

export const ENQUIRY_FORM_SUBMIT_CLIENT_FAILED: AnalyticsEvent = {
  category: "Enquiry Form",
  action: "Submit",
  label: "Client Enquiry Submitted - Failed",
};
